/**
 * Legacy `/admin/*` URLs — strip prefix and redirect to TanStack file routes.
 * e.g. `/admin/tasks` → `/tasks`, `/admin/integrations/crm` → `/integrations/crm`
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/$")({
  beforeLoad: ({ params }) => {
    const rest = (params._splat ?? "").replace(/^\/+/, "");
    throw redirect({ href: rest ? `/${rest}` : "/dashboard" });
  },
});
